import { createUuid } from './createUuid';
import { uploadIssueAttachment } from '../api/issues';

export const ISSUE_FILE_ACCEPT =
  '.pdf,.png,.jpg,.jpeg,.webp,.gif,.doc,.docx';

export const ISSUE_FILE_HINT =
  'PDF, фото или Word — до 10 МБ. Можно несколько файлов.';

export const TACH_FILE_ACCEPT = '.png,.jpg,.jpeg,.webp,.gif';

export const TACH_FILE_HINT =
  'Фото тахометра — до 10 МБ. Можно несколько файлов.';

export async function uploadIssueFiles(
  issueId: number,
  files: File[]
): Promise<number> {
  if (files.length === 0) return 0;
  const groupId = createUuid();
  let okCount = 0;
  for (const file of files) {
    await uploadIssueAttachment(issueId, file, groupId);
    okCount += 1;
  }
  return okCount;
}
